'use client';

import { c as _c } from "react/compiler-runtime";
import { Alert, AlertBody, Drawer, Heading, TextPassage } from '@petsmart-ui/sparky';
import { useEffect, useId, useState } from 'react';
import { FormProvider, useWatch } from 'react-hook-form';
import { CartConfirmDrawer } from '../CartConfirmDrawer';
import { PDPStoreDrawer } from '../pdp-store-drawer';
import { SddAddressDrawer } from '../SddAddressDrawer';
import { MiniPdpProductInfo } from './mini-pdp-product-info';
import { MiniPdpPurchaseForm } from './mini-pdp-purchase-form';
import { MiniPdpSkeleton } from './mini-pdp-skeleton';
import { useMiniPdpDrawer } from './model/use-mini-pdp-drawer';
import { useMiniPdpErrorAnalytics } from './model/use-mini-pdp-error-analytics';
import { useMiniPdpForm } from './model/use-mini-pdp-form';
import { useMiniPdpProduct } from './model/use-mini-pdp-product';
import type { MiniPdpDrawerProps } from './types';
import './mini-pdp-drawer.scss';
export function MiniPdpDrawer(t0) {
  const $ = _c(58);
  const {
    className
  } = t0;
  const isOpen = useMiniPdpDrawer(_temp);
  const close = useMiniPdpDrawer(_temp2);
  const {
    base,
    tailored,
    isLoading,
    isError,
    isUnexpectedError
  } = useMiniPdpProduct();
  const defaultProduct = base?.variants[base.defaultSku];
  const purchaseTailored = isError ? null : tailored;
  const form = useMiniPdpForm(defaultProduct, base?.defaultSku);
  const [isSddAddressOpen, setIsSddAddressOpen] = useState(false);
  let t1;
  if ($[0] !== form.control) {
    t1 = {
      control: form.control,
      name: "selectedSku"
    };
    $[0] = form.control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectedSku = useWatch(t1);
  const resolvedSku = base?.variants[selectedSku] ? selectedSku : base?.defaultSku;
  const selectedProduct = resolvedSku && base ? base.variants[resolvedSku] : undefined;
  const [isStoreDrawerOpen, setIsStoreDrawerOpen] = useState(false);
  const [isAddToCartError, setIsAddToCartError] = useState(false);
  const [isSddAddressError, setIsSddAddressError] = useState(false);
  const showError = isError || isAddToCartError;
  useMiniPdpErrorAnalytics(isUnexpectedError || isAddToCartError || isSddAddressError);
  const headingId = useId();
  const [hasBeenRendered, setHasBeenRendered] = useState(false);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setHasBeenRendered(true);
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  const t4 = !isOpen;
  let t5;
  if ($[4] !== close || $[5] !== t4) {
    t5 = <CartConfirmDrawer stacked={true} forceClosed={t4} onCloseAll={close} />;
    $[4] = close;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const cartConfirmDrawer = t5;
  if (!hasBeenRendered) {
    return cartConfirmDrawer;
  }
  let t6;
  if ($[7] !== close || $[8] !== isSddAddressOpen || $[9] !== isStoreDrawerOpen) {
    t6 = () => !isSddAddressOpen && !isStoreDrawerOpen && close();
    $[7] = close;
    $[8] = isSddAddressOpen;
    $[9] = isStoreDrawerOpen;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = className ? `mini-pdp-drawer ${className}` : "mini-pdp-drawer";
  let t8;
  if ($[11] !== headingId) {
    t8 = <Drawer.Header className="mini-pdp-drawer__header"><Heading id={headingId} tagName="h2" size="headline" data-testid="mini-pdp-drawer-title">Choose Options</Heading></Drawer.Header>;
    $[11] = headingId;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = base ? "true" : "false";
  const t10 = purchaseTailored ? "true" : "false";
  let t11;
  if ($[13] !== showError) {
    t11 = showError && <Alert variant="error" iconName="exclamation-circle-fill" className="mini-pdp-drawer__error" data-testid="mini-pdp-error" dismissible={false}><AlertBody><Heading tagName="h2" size="body-bold">Unexpected error has occurred</Heading><TextPassage capLinelength={false}>Please refresh page to continue.</TextPassage></AlertBody></Alert>;
    $[13] = showError;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== isLoading || $[16] !== selectedProduct || $[17] !== showError) {
    t12 = (isLoading || showError) && !selectedProduct && <MiniPdpSkeleton />;
    $[15] = isLoading;
    $[16] = selectedProduct;
    $[17] = showError;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== base || $[20] !== isError || $[21] !== isLoading || $[22] !== purchaseTailored || $[23] !== selectedProduct) {
    t13 = selectedProduct && <div className="mini-pdp-drawer__options"><MiniPdpProductInfo product={selectedProduct} /><MiniPdpPurchaseForm base={base} product={selectedProduct} tailored={purchaseTailored} isLoading={isLoading} isError={isError} onErrorChange={setIsAddToCartError} onOpenSddAddress={() => setIsSddAddressOpen(true)} onOpenStoreDrawer={() => setIsStoreDrawerOpen(true)} /></div>;
    $[19] = base;
    $[20] = isError;
    $[21] = isLoading;
    $[22] = purchaseTailored;
    $[23] = selectedProduct;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t12 || $[28] !== t13 || $[29] !== t9) {
    t14 = <Drawer.Body className="mini-pdp-drawer__body" data-testid="mini-pdp-drawer-body"><div className="mini-pdp-drawer__product" data-testid="mini-pdp-product-data" data-base-loaded={t9} data-tailored-loaded={t10}>{t11}{t12}{t13}</div></Drawer.Body>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
    $[29] = t9;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== headingId || $[32] !== isOpen || $[33] !== t14 || $[34] !== t6 || $[35] !== t7 || $[36] !== t8) {
    t15 = <Drawer align="right" isActive={isOpen} onClose={t6} data-testid="mini-pdp-drawer" className={t7} ariaLabelledBy={headingId} dismissible={true}>{t8}{t14}</Drawer>;
    $[31] = headingId;
    $[32] = isOpen;
    $[33] = t14;
    $[34] = t6;
    $[35] = t7;
    $[36] = t8;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  const t16 = !isOpen;
  const t17 = Boolean(resolvedSku && tailored?.variants?.[resolvedSku]?.SDD?.doorDashValidationSuccess);
  let t18;
  if ($[38] !== close || $[39] !== isError || $[40] !== isLoading || $[41] !== isSddAddressOpen || $[42] !== t16 || $[43] !== t17) {
    t18 = <SddAddressDrawer showBackButton={true} showTrigger={false} isOpen={isSddAddressOpen} onOpenChange={setIsSddAddressOpen} onErrorChange={setIsSddAddressError} forceClosed={t16} onCloseAll={close} isDeliveryAvailable={t17} isLoading={isLoading} isError={isError} />;
    $[38] = close;
    $[39] = isError;
    $[40] = isLoading;
    $[41] = isSddAddressOpen;
    $[42] = t16;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  const t19 = !isOpen;
  const t20 = selectedProduct?.deliveryMethods?.BOPIS?.purchaseQuantities?.min;
  const t21 = resolvedSku ? _temp4 : undefined;
  let t22;
  if ($[45] !== close || $[46] !== isStoreDrawerOpen || $[47] !== resolvedSku || $[48] !== t19 || $[49] !== t20 || $[50] !== t21) {
    t22 = <PDPStoreDrawer showBackButton={true} forceClosed={t19} onCloseAll={close} isActive={isStoreDrawerOpen} onOpenChange={setIsStoreDrawerOpen} sku={resolvedSku} drawerHeading="Pick up in store" toggleText="Only stores with item availability" className="pdp-page" minPurchaseQuantity={t20} filterFn={t21} />;
    $[45] = close;
    $[46] = isStoreDrawerOpen;
    $[47] = resolvedSku;
    $[48] = t19;
    $[49] = t20;
    $[50] = t21;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== cartConfirmDrawer || $[53] !== form || $[54] !== t15 || $[55] !== t18 || $[56] !== t22) {
    t23 = <FormProvider {...form}>{t15}{t18}{t22}{cartConfirmDrawer}</FormProvider>;
    $[52] = cartConfirmDrawer;
    $[53] = form;
    $[54] = t15;
    $[55] = t18;
    $[56] = t22;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  return t23;
}
function _temp4(stores) {
  return stores.filter(_temp3);
}
function _temp3(store) {
  return store.attributes?.bopisEnabled;
}
function _temp2(state_0) {
  return state_0.close;
}
function _temp(state) {
  return state.isOpen;
}